module.exports = __webpack_public_path__ + "static/media/contacts.160f8132.svg";